<template>
  <div class="position-relative pr-2">
    <slot></slot>

    <div class="position-absolute" style="top: 0;right: 0;">
      <feather-icon
        icon="EditIcon"
        :id="`edit-column-${_uid}`"
        ref="button"
        class="text-info cursor-pointer"
      />

      <b-popover
        custom-class="edit-column-popover"
        style="width: 400px"
        ref="popover"
        :target="`edit-column-${_uid}`"
        triggers="click"
        :show.sync="popoverShow"
        placement="top"
        @show="onShow"
        @hidden="onHidden"
      >
        <template v-slot:title>
          <div class="d-flex justify-content-between align-items-center">
            <span>Edit {{column.label}}</span>
            <feather-icon icon="XIcon" @click="onClose" class="cursor-pointer"/>
          </div>
        </template>

        <validation-observer ref="formRef" #default="{invalid}">
          <validation-provider #default="{ errors }" :name="column.key">

            <template v-if="column.edit_options.type === 'text'">
              <b-form-input
                v-model="localItem[column.key]"
                :state="errors.length > 0 ? false:null"
                type="text"
                :placeholder="column.label"
              />
            </template>
            <template v-if="column.edit_options.type === 'select'">
              <v-select
                v-model="localItem[column.key]"
                :class="{'is-invalid': errors.length > 0}"
                :options="column.edit_options.options"
                :placeholder="column.label"
                :reduce="i => i.id"
              />
            </template>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <b-overlay no-wrap :show="loading"/>
        </validation-observer>

        <div class="d-flex justify-content-end mt-50">
          <b-button size="sm" variant="warning"  @click="onReset">Reset</b-button>
          <b-button size="sm" variant="primary" class="ml-50" @click="onEdit">Edit</b-button>
        </div>


      </b-popover>
    </div>

  </div>
</template>
<script>
import {
  BPopover,
  BButton,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import VSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  components: {
    BPopover,
    BButton,
    BFormInput,
    BOverlay,

    ValidationProvider,
    ValidationObserver,
    VSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    item: Object,
    column: Object,
    fetchEditColumn: Function,
  },
  data: () => ({
    loading: false,
    popoverShow: false,
    localItem: null
  }),
  methods: {
    onClose(){
      this.popoverShow = false
    },
    onReset() {
      this.localItem = JSON.parse(JSON.stringify(this.item))
    },
    async onEdit() {
      this.loading = true

      try {
        await this.fetchEditColumn(this.column, this.localItem)

        this.$set(this.item, this.column.key, this.localItem[this.column.key])

        this.$set(this.item, '_cellVariants', {[this.column.key]: 'success'})

        setTimeout(() => {
          this.$set(this.item, '_cellVariants', null)
        }, 2000)

        this.onClose()

      } catch (e) {

        this.loading = false
        this.$refs.formRef.setErrors(e.errors)

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {title: e.message, icon: 'AlertTriangleIcon', variant: 'danger',},
        })
      }
    },
    onShow() {
      this.localItem = JSON.parse(JSON.stringify(this.item))
    },
    onHidden(){
      this.localItem = null;
      this.loading = false;
    }
  },
}
</script>
<style>
.edit-column-popover {
  max-width: 350px;
  width: 350px;
}
</style>